export default __webpack_public_path__ + "static/thumb-landscape-6b40b640ba4f298c93094cbcb4fed824.jpg";